import React from 'react'
// Assets
import searchImage from '../../../static/ic-search.png'
// Components(styles)
import { Form, SearchField, SearchButton, SearchImg } from './styles'
// Util
import { removeSpecialChars } from '../../../utils/textSlug'

export const searchFilter = (searchValue, list) => {
  if (searchValue && searchValue.length > 2) {
    return list.filter(({ codIdentificador, veiculo, informacoesGerenciais }) => {
      const onlyChars = removeSpecialChars(searchValue)
      return (
        codIdentificador.includes(onlyChars.toUpperCase()) ||
        veiculo.placa.includes(onlyChars.toUpperCase()) ||
        (informacoesGerenciais &&
          informacoesGerenciais
            .map(inf => ({ ...inf, descricaoAtual: removeSpecialChars(inf.descricaoAtual) }))
            .some(inf => inf.descricaoAtual.includes(onlyChars)))
      )
    })
  }
  return list
}

export const SearchForm = props => {
  const { onSearch = null, width } = props || {}

  const handleSearch = e => {
    if (onSearch) {
      e.preventDefault()
      e.stopPropagation()
      onSearch()
    }
  }

  return (
    <Form width={width}>
      <SearchField type="text" name="search" {...props} id="inputBuscaIdentificador" />
      <SearchButton onClick={handleSearch} id="btnBuscaIdentificador">
        <SearchImg src={searchImage} alt="Search Image" />
      </SearchButton>
    </Form>
  )
}

export default SearchForm



// WEBPACK FOOTER //
// ./src/app/modules/SearchForm/index.js